import { useDictionaryContext } from 'application/contexts/DictionaryContext';
import { usePageContext } from 'application/contexts/PageContext';
import { Breadcrumb } from 'designsystem/components/1-atoms/Breadcrumb';
import { LinkFeature } from 'features/Modules/Link';
import { ExcludedFromCludo } from 'helpers/ExcludedFromCludo';
import { useRouter } from 'next/router';

export const BreadcrumbFeature: React.FC = () => {
	const pageContext = usePageContext();
	const { breadcrumb } = pageContext ?? {};
	const dictionary = useDictionaryContext();
	const router = useRouter();
	const currentLocale = router?.locale?.toLowerCase();

	return breadcrumb?.length > 0 ? (
		<ExcludedFromCludo>
			<Breadcrumb
				className="rs_skip"
				id={`breadcrumb-${currentLocale}`}
				breadcrumbItems={breadcrumb?.map((item, index) => {
					return <LinkFeature key={index} url={item.url} title={item.title} />;
				})}
				label={dictionary.getLabel('BreadcrumbNavigation')}
			/>
		</ExcludedFromCludo>
	) : null;
};
